var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download",
    d: "M0,16a7.678,7.678,0,0,0,1.824,5.088A7.94,7.94,0,0,0,6.4,23.84a.028.028,0,0,0,.032-.032v-.064l.032-.032a6.756,6.756,0,0,1,1.344-2.176,4.491,4.491,0,0,1,2.208-1.184V18.016a5.852,5.852,0,0,1,1.728-4.256A5.73,5.73,0,0,1,16,12a5.73,5.73,0,0,1,4.256,1.76,5.968,5.968,0,0,1,1.76,4.256v2.336a4.692,4.692,0,0,1,2.176,1.216,6.825,6.825,0,0,1,1.344,2.144l.1.288h.384A6.009,6.009,0,0,0,32,18.016V16a6.009,6.009,0,0,0-5.984-5.984,2.6,2.6,0,0,0-.32.032A7.759,7.759,0,0,0,26.016,8a7.624,7.624,0,0,0-2.368-5.632A7.861,7.861,0,0,0,18.016,0,7.634,7.634,0,0,0,12.96,1.824a8.092,8.092,0,0,0-2.784,4.544A7.457,7.457,0,0,0,8,6.016,7.782,7.782,0,0,0,2.336,8.352,7.552,7.552,0,0,0,0,14.016V16Zm10.016,9.824a1.888,1.888,0,0,0,.576,1.6l4,4a2.009,2.009,0,0,0,2.816,0l4-4a1.978,1.978,0,0,0,.608-1.6,3.724,3.724,0,0,0-.16-.576,1.794,1.794,0,0,0-.736-.9A2.308,2.308,0,0,0,20,24H18.016V18.016a1.865,1.865,0,0,0-.608-1.408A2.115,2.115,0,0,0,16,16a1.782,1.782,0,0,0-1.408.608,1.883,1.883,0,0,0-.576,1.408V24H12a1.936,1.936,0,0,0-1.12.352,2,2,0,0,0-.736.9A2.794,2.794,0,0,0,10.016,25.824Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c417b38ab6c2d7c26ebd0effc000e6a3.svg";
export { ForwardRef as ReactComponent };